import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d0c5709"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "accordion-005",
  open: ""
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "仮仕様情報", -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "w20p",
  for: ""
}, "製本仕様", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "w20p",
  for: ""
}, "判型", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "w20p",
  for: ""
}, "1Cページ数", -1))
const _hoisted_9 = {
  key: 0,
  class: "error_message"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "w20p",
  for: ""
}, "4Cページ数", -1))
const _hoisted_11 = {
  key: 0,
  class: "error_message"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "w20p",
  for: ""
}, "重量", -1))
const _hoisted_13 = { class: "error_message" }

import { useStore } from "vuex";
import { computed, onMounted, ref, watch, watchEffect } from "vue";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'KikakuKarisiyou',
  props: {
  kikakuData: Object,
},
  setup(__props, { expose: __expose }) {

const store = useStore();
const seihonSiyoId = ref();
const hangataId = ref();
const singleColorQty = ref();
const fullColorQty = ref();
const weight = ref();

const kikakuId = ref();
const kikakuMei = ref("");
const kikakuMeiKana = ref("");
const syohinKbnId = ref();
const syohinBunruiId = ref();
const hannyuKiboYearAndMonth = ref("");
const version = ref();
const seihonsiyo = ref();
const hangata = ref();

const props = __props;


watchEffect(() => {
  if (props.kikakuData) {
    kikakuId.value = props.kikakuData.kikakuId || null;
    seihonSiyoId.value = props.kikakuData.kariSiyo.seihonSiyoId|| null;
    hangataId.value = props.kikakuData.kariSiyo.hangataId|| null;
    singleColorQty.value =
      parseInt(props.kikakuData.kariSiyo.singleColorPageQty, 10)|| null;
    fullColorQty.value =
      parseInt(props.kikakuData.kariSiyo.fullColorPageQty, 10)|| null;
    weight.value = parseInt(props.kikakuData.kariSiyo.weight, 10)|| null;
  }
});

watch(
  [kikakuId, seihonSiyoId, hangataId, singleColorQty, fullColorQty, weight],
  () => {
    store.commit("createKikaku", {
      kariSiyo: {
        // ネストされた形式でpayloadを構築
        kikakuId: kikakuId.value|| null,
        seihonSiyoId: seihonSiyoId.value|| null,
        hangataId: hangataId.value|| null,
        singleColorQty: parseInt(singleColorQty.value, 10) || null,
        fullColorQty: parseInt(fullColorQty.value, 10) || null,
        weight: parseInt(weight.value, 10) || null,
      },
    });
  }
);

onMounted(() => {
  // 製本仕様
  axios
    .get(`${store.getters["getBaseUrl"]}/searchItemList/seihon-siyo`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
    .then((res) => {
      seihonsiyo.value = res.data;
    });

  // 判型
  axios
    .get(`${store.getters["getBaseUrl"]}/searchItemList/hangata`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
    .then((res) => {
      hangata.value = res.data;
    });
});
const isShowError = ref(false);

const errorList = ref({
  singleColorQty: "",
  fullColorQty:"",
  weight:""
});


let regex = /^[0-9]*$/

const validDataKariSiyo = () => {
  isShowError.value = false;
  
  errorList.value = {
    singleColorQty: "",
    fullColorQty:"",
    weight:""
  };
  // タイトル
  if (singleColorQty.value && !regex.test(singleColorQty.value)) {
    isShowError.value = true;
    errorList.value.singleColorQty = "半角数字で入力してください";
  }
  if (fullColorQty.value && !regex.test(fullColorQty.value)) {
    isShowError.value = true;
    errorList.value.fullColorQty = "半角数字で入力してください";
  }
  if (weight.value && !regex.test(weight.value)) {
    isShowError.value = true;
    errorList.value.weight = "半角数字で入力してください";
  }
  if (isShowError.value) {
    return true;
  } else {
    return false;
  }
};
__expose({
  validDataKariSiyo,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("details", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          name: "",
          id: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((seihonSiyoId).value = $event)),
          class: "w20p"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seihonsiyo.value, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: option.seihonSiyoId,
              key: index
            }, _toDisplayString(option.seihonSiyo), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vModelSelect, seihonSiyoId.value]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _withDirectives(_createElementVNode("select", {
          name: "",
          id: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((hangataId).value = $event)),
          class: "w20p"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hangata.value, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: option.hangataId,
              key: index
            }, _toDisplayString(option.hangata), 9, _hoisted_7))
          }), 128))
        ], 512), [
          [_vModelSelect, hangataId.value]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((singleColorQty).value = $event)),
          class: "text_box"
        }, null, 512), [
          [_vModelText, singleColorQty.value]
        ]),
        (isShowError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errorList.value.singleColorQty), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fullColorQty).value = $event)),
          class: "text_box"
        }, null, 512), [
          [_vModelText, fullColorQty.value]
        ]),
        (isShowError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errorList.value.fullColorQty), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((weight).value = $event)),
          class: "text_box"
        }, null, 512), [
          [_vModelText, weight.value]
        ]),
        _createElementVNode("p", _hoisted_13, _toDisplayString(errorList.value.weight), 1)
      ])
    ])
  ]))
}
}

})